// GestionInventarioCuadrePage.tsx

import { PermissionsEnum } from "@/auth/interfaces";
import { hasPermission, sizeTab, a11yProps } from "@/shared";
import { CustomTabPanel, SingleTableBoxScene } from "@/shared/components/ui";
import { Box, Tabs, Tab } from "@mui/material";
import { useState } from "react";
import TablaGestionInventario from "../../components/table-gestion-inventario-cuadre/TablaGestionInventario";

export default function GestionInventarioCuadrePage() {

  hasPermission(PermissionsEnum.api_view_gestioninventariocuadre)

  const [valueTab, setValueTab] = useState(0);

  return (
    <SingleTableBoxScene title={"Gestion Inventario Cuadre"}
      py={2}
      visibleReport={true}

    >
      <Box sx={{ bgcolor: 'background.paper', maxWidth: sizeTab, paddingBottom: 3 }} >
        <Tabs
          value={valueTab}
          onChange={(_event: React.SyntheticEvent, newValue: number) => {
            setValueTab(newValue);
          }}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          aria-label="scrollable force tabs gestioninventariocuadre"
        >
          <Tab label={'Pendiente'} {...a11yProps(0)} />
          <Tab label={'Gestión'} {...a11yProps(1)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={valueTab} index={0}>
        <TablaGestionInventario estado="EN ESPERA" />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={1}>
        <TablaGestionInventario estado="EN GESTION" />
      </CustomTabPanel>
    </SingleTableBoxScene >
  )
}